module.exports = __webpack_public_path__ + "static/media/buy_req_rent_4.2fc7c037.png";